/* EDX – Trang sản phẩm tím (Agent 12, 18/10/2026): thanh mua, Đặt nhanh, Hỏi bé, video, mùi tương tự, vừa xem. Không thư viện ngoài.
   Tin báo về shop: gửi tới window.edxRelay (link Google Apps Script, lưu ở metafield shop edx.relay_url). Trống thì chỉ mở Zalo. */
(function () {
  if (window.edxSpReady) return;
  window.edxSpReady = true;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var el = $('[data-edx-sp-data]'), D = {};
  try { D = JSON.parse(el ? el.textContent : '{}'); } catch (e) { D = {}; }
  var V = D.variants || [];
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var code = Math.random().toString(36).slice(2, 6).toUpperCase();

  function form() { return $('.product-information form[action*="/cart/add"]') || $('form[data-type="add-to-cart-form"]'); }
  function cur() {
    var f = form(), inp = f && f.querySelector('[name="id"]'), id = inp ? parseInt(inp.value, 10) : 0, i;
    for (i = 0; i < V.length; i++) if (V[i].id === id) return V[i];
    for (i = 0; i < V.length; i++) if (V[i].a) return V[i];
    return V[0] || { id: 0, t: '', p: '', a: false };
  }
  function size(v) { return v.t && v.t !== 'Default Title' ? v.t : (D.size || ''); }
  function sync() {
    var v = cur(), s = size(v);
    $$('[data-buy-s]').forEach(function (n) { n.textContent = v.p + (s ? ' · ' + s : ''); });
    $$('[data-edx-buy]').forEach(function (b) {
      b.disabled = !v.a;
      var l = b.querySelector('[data-buy-l]');
      if (l) l.textContent = v.a ? (b.getAttribute('data-l-on') || 'Mua ngay') : (b.getAttribute('data-l-off') || 'Tạm hết hàng');
    });
    $$('[data-sheet-v]').forEach(function (n) { n.textContent = s; n.hidden = !s; });
    $$('[data-sheet-pr]').forEach(function (n) { n.textContent = v.p; });
  }
  /* Horizon đổi phiên bản rồi mới cập nhật ô id: đọc lại vài lần */
  document.addEventListener('change', function (e) {
    if (!(e.target.closest && e.target.closest('variant-picker'))) return;
    [150, 600, 1500, 3000].forEach(function (ms) { setTimeout(sync, ms); });
  }, true);

  function relay(loai, extra) {
    var u = window.edxRelay; if (!u) return false;
    var v = cur(), b = { loai: loai, ma: code, san_pham: D.title || document.title, dung_tich: size(v), gia: v.p, link: D.url || location.href, gio: new Date().toLocaleString('vi-VN') }, k;
    extra = extra || {};
    for (k in extra) b[k] = extra[k];
    var s = JSON.stringify(b);
    try { if (navigator.sendBeacon && navigator.sendBeacon(u, new Blob([s], { type: 'text/plain;charset=utf-8' }))) return true; } catch (e) {}
    try { fetch(u, { method: 'POST', mode: 'no-cors', keepalive: true, body: s }); return true; } catch (e) {}
    return false;
  }
  window.edxRelaySend = relay;
  function relayUI() {
    var on = !!window.edxRelay;
    $$('[data-relay-only]').forEach(function (n) { n.hidden = !on; });
    $$('[data-no-relay]').forEach(function (n) { n.hidden = on; });
  }

  var tEl = null, tT = null;
  function toast(msg) {
    if (!msg) return;
    if (!tEl) { tEl = document.createElement('div'); tEl.className = 'edx-toast'; tEl.setAttribute('role', 'status'); document.body.appendChild(tEl); }
    tEl.textContent = msg; tEl.hidden = false; clearTimeout(tT);
    tT = setTimeout(function () { tEl.hidden = true; }, 6000);
  }
  function openZalo(url) { var w = window.open(url, '_blank'); if (w) { try { w.opener = null; } catch (e) {} } else { location.href = url; } }
  function post(items) {
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    /* Nút Zalo: báo shop trước rồi để link mở Zalo như thường */
    var a = t.closest('[data-edx-relay]');
    if (a) relay(a.getAttribute('data-edx-relay'));

    /* Mua ngay: thêm vào giỏ rồi sang trang thanh toán */
    var b = t.closest('[data-edx-buy]');
    if (b) {
      e.preventDefault();
      sync();
      var v = cur();
      if (!v.a || b.getAttribute('aria-busy') === 'true') return;
      var f = form(), q = (f && f.querySelector('input[name="quantity"]')) || $('.product-information input[name="quantity"]');
      var items = [{ id: v.id, quantity: Math.max(1, parseInt(q && q.value, 10) || 1) }];
      var mk = $('edx-mua-kem'), ck = mk && mk.querySelector('.edx-mk__check');
      if (ck && ck.checked && mk.getAttribute('data-kem-id')) items.push({ id: Number(mk.getAttribute('data-kem-id')), quantity: 1 });
      b.setAttribute('aria-busy', 'true');
      post(items).then(function () { location.href = ROOT + 'checkout'; })
        .catch(function () { b.removeAttribute('aria-busy'); toast(b.getAttribute('data-err')); });
      return;
    }

    /* Đặt nhanh: mở bảng dưới */
    if (t.closest('[data-edx-open-sheet]')) {
      var sh = $('[data-edx-sheet]');
      if (sh) { sync(); relayUI(); if (sh.showModal) sh.showModal(); else sh.setAttribute('open', ''); }
      return;
    }
    var x = t.closest('[data-edx-close]');
    if (x) { var d = x.closest('dialog'); if (d) d.close(); return; }
    if (t.tagName === 'DIALOG' && (t.classList.contains('edx-sheet') || t.classList.contains('edx-vdlg'))) { t.close(); return; }

    /* Hỏi bé: báo shop câu hỏi + tên chai, chép sẵn câu hỏi, mở Zalo */
    var q2 = t.closest('[data-edx-ask]');
    if (q2) {
      e.preventDefault();
      var box = q2.closest('[data-edx-hb]'), ph = box && box.querySelector('[name="sdt"]');
      var ques = q2.getAttribute('data-edx-ask') || '', v2 = cur(), s2 = size(v2);
      var msg = (ques ? ques + '\n' : '') + (D.title || '') + (s2 ? ' (' + s2 + ')' : '') + '\n' + (D.url || location.href) + '\nMã: ' + code;
      try { if (navigator.clipboard) navigator.clipboard.writeText(msg).catch(function () {}); } catch (err) {}
      var sent = relay('hoi', { cau_hoi: ques || '(khách bấm Hỏi câu khác)', sdt: ph ? ph.value.replace(/[^0-9+]/g, '') : '' });
      var tx = box ? box.getAttribute(sent ? 'data-t-sent' : 'data-t-copy') : '';
      toast((tx || '').replace('{ma}', code));
      openZalo(D.zalo || q2.getAttribute('href'));
      return;
    }

    /* Video: mở khung xem */
    var c = t.closest('[data-edx-vsrc]');
    if (c) {
      var sec = c.closest('[data-edx-vd]'), dl = sec && sec.querySelector('dialog');
      if (!dl) return;
      e.preventDefault();
      var fr = dl.querySelector('.edx-vdlg__f'), src = c.getAttribute('data-edx-vsrc'), m;
      dl.classList.toggle('is-vert', c.getAttribute('data-vert') === '1');
      fr.innerHTML = '';
      if (c.getAttribute('data-kind') === 'mp4') { m = document.createElement('video'); m.src = src; m.controls = true; m.autoplay = true; m.playsInline = true; }
      else { m = document.createElement('iframe'); m.src = src; m.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen'); m.setAttribute('allowfullscreen', ''); m.title = c.getAttribute('aria-label') || 'Video'; }
      fr.appendChild(m);
      if (dl.showModal) dl.showModal(); else dl.setAttribute('open', '');
      return;
    }

    /* Mua cùng: thêm 1 món vào giỏ */
    var ad = t.closest('[data-edx-add]');
    if (ad && !ad.disabled) {
      e.preventDefault(); ad.disabled = true;
      post([{ id: Number(ad.getAttribute('data-edx-add')), quantity: 1 }]).then(function () {
        ad.textContent = '✓'; ad.setAttribute('aria-label', ad.getAttribute('data-done') || ''); toast(ad.getAttribute('data-done'));
      }).catch(function () { ad.disabled = false; toast('Chưa thêm được, chị thử lại nhé.'); });
    }
  });
  $$('dialog.edx-vdlg').forEach(function (d) { d.addEventListener('close', function () { var f = d.querySelector('.edx-vdlg__f'); if (f) f.innerHTML = ''; }); });

  /* Đặt nhanh: gửi số điện thoại */
  var qf = $('[data-edx-quick]');
  if (qf) qf.addEventListener('submit', function (e) {
    e.preventDefault();
    var inp = qf.querySelector('[name="sdt"]'), sdt = (inp.value || '').replace(/[^0-9+]/g, '');
    var ok = qf.querySelector('[data-ok]'), err = qf.querySelector('[data-err]'), btn = qf.querySelector('button[type="submit"]');
    if (sdt.length < 9) { err.textContent = qf.getAttribute('data-bad'); err.hidden = false; inp.focus(); return; }
    err.hidden = true; btn.disabled = true;
    if (relay('dat_nhanh', { sdt: sdt })) { ok.hidden = false; btn.hidden = true; inp.disabled = true; }
    else { btn.disabled = false; err.textContent = qf.getAttribute('data-fail'); err.hidden = false; }
  });

  /* Mùi tương tự + Mua cùng (gợi ý của Shopify) */
  function low(s) { return (s || '').toLowerCase().trim(); }
  function grab(url, sel) {
    return fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (h) {
      return h ? new DOMParser().parseFromString(h, 'text/html').querySelectorAll(sel) : [];
    });
  }
  $$('[data-edx-rec]').forEach(function (sec) {
    var mine = (sec.getAttribute('data-notes') || '').split('|').filter(Boolean), ml = mine.map(low);
    var list = sec.querySelector('[data-edx-rec-list]'), max = parseInt(sec.getAttribute('data-max') || '8', 10);
    grab(sec.getAttribute('data-edx-rec'), '[data-edx-rec-items] > li').then(function (items) {
      var n = 0;
      Array.prototype.forEach.call(items, function (li) {
        if (n >= max) return;
        var theirs = (li.getAttribute('data-notes') || '').split('|').map(low), hit = '', i;
        for (i = 0; i < ml.length && !hit; i++) if (ml[i] && theirs.indexOf(ml[i]) > -1) hit = mine[i];
        var chip = li.querySelector('[data-like]');
        if (chip && hit) { chip.textContent = (sec.getAttribute('data-like') || 'Giống ở:') + ' ' + hit.toLowerCase(); chip.hidden = false; }
        list.appendChild(document.importNode(li, true)); n++;
      });
      if (n) sec.hidden = false;
    }).catch(function () {});
    var box = sec.querySelector('[data-edx-mc-box]'), mcUrl = sec.getAttribute('data-edx-mc');
    if (box && mcUrl) grab(mcUrl, '[data-edx-mc-items] > .edx-mc__r').then(function (rows) {
      var to = box.querySelector('[data-edx-mc-list]');
      Array.prototype.forEach.call(rows, function (r) { to.appendChild(document.importNode(r, true)); });
      if (rows.length) { box.hidden = false; sec.hidden = false; }
    }).catch(function () {});
  });

  /* Nhớ chai vừa xem (cho mục Chị vừa xem) */
  if (D.handle) {
    try {
      var L = JSON.parse(localStorage.getItem('edx_seen') || '[]');
      if (!Array.isArray(L)) L = [];
      L = [D.handle].concat(L.filter(function (h) { return h && h !== D.handle; })).slice(0, 8);
      localStorage.setItem('edx_seen', JSON.stringify(L));
    } catch (e) {}
  }
  relayUI(); sync();
})();